import type { UserCardState, UserReducerAction } from '../../types';

export const SetUserReducer = (state: UserCardState, action: UserReducerAction): UserCardState => {
    switch (action?.type) {
        case 'SET':
            return action.value ? { ...action.value } : null;

        case 'SET_GENERAL_FIELD':
            return state
                ? {
                      ...state,
                      [action.field]: action.value,
                  }
                : state;

        case 'SET_ACCESS_FIELD':
            return state
                ? {
                      ...state,
                      access: {
                          ...(state.access ?? {}),
                          [action.field]: action.value,
                      },
                  }
                : state;

        case 'SET_INFO_FIELD':
            return state
                ? {
                      ...state,
                      info: {
                          ...(state.info ?? {}),
                          [action.field]: action.value,
                      },
                  }
                : state;

        case 'SET_TELEGRAM_EVENTS_FIELD':
            return state
                ? {
                      ...state,
                      telegramEvents: {
                          ...(state.telegramEvents ?? {}),
                          [action.field]: action.value,
                      },
                  }
                : state;

        default:
            return state;
    }
};
